import React from 'react';
import { Styler, Image, Carousel, CarouselViewport, CarouselSlide, CarouselDotButtons, } from '@honeycomb/ui-core';
import { useResponsiveHotelImages } from '../utils';
function ImageLink(props) {
    // A link to wrap a hotel image.
    return React.createElement(Styler, Object.assign({ component: "a", "aria-hidden": true, tabIndex: "-1", display: "block", h: "100%" }, props));
}
export function HotelCardImageCarousel({ children, estabId, cropDims: imageCropSizes, imageCount, hotelName, ImageLinkProps, }) {
    // Compose an array of hotel image urls
    const images = useResponsiveHotelImages({ estabId, cropDims: imageCropSizes, imageCount });
    // Single image (or placeholder)
    if (images.length < 2) {
        return (React.createElement(Styler, { h: "100%", pos: "relative" },
            React.createElement(ImageLink, Object.assign({}, ImageLinkProps),
                React.createElement(Image, { src: images.length === 1 ? images[0] : null, withPlaceholder: true, h: "100%" })),
            children));
    }
    return (React.createElement(Carousel, { slideSpacing: 0, visibleSlides: 1, title: `${hotelName} image carousel` },
        React.createElement(CarouselViewport, { h: "100%", ArrowButtonProps: { size: 's' } }, images.map((src, index) => {
            const alt = `${hotelName} (${index + 1})`;
            return (React.createElement(CarouselSlide, { key: alt },
                React.createElement(ImageLink, Object.assign({}, ImageLinkProps),
                    React.createElement(Image, { src: src, alt: alt, withPlaceholder: true, h: "100%", pos: "absolute" }))));
        })),
        React.createElement(Styler, { pos: "absolute", bottom: 1, left: 0, right: 0, m: "0 auto", w: "fit-content", zIndex: 3 },
            React.createElement(CarouselDotButtons, { bg: "transparent" })),
        children));
}
